import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import {Menu, Sidebar} from 'semantic-ui-react';

class ScenePlanetSidebar extends Component {

    shouldComponentUpdate({location: {
            pathname
        }, visible}) {
        return pathname !== this.props.location.pathname || visible !== this.props.visible;
    }

    render() {
        const {route, visible} = this.props;
        return <Sidebar as={Menu} vertical={true} inverted={true} animation='overlay' visible={visible}>
            <Menu.Item as={NavLink} to={`${route}/test`}>Test</Menu.Item>
        </Sidebar>;
    }
}

const connectedSidebar = connect(({routes: {
        scenePlanet
    }}) => ({route: scenePlanet}))(ScenePlanetSidebar);
export default withRouter(connectedSidebar);


// WEBPACK FOOTER //
// ./src/apps/scene-planet/components/Sidebar.js